<template>
  <div class="flex flex-wrap gap-6">
    <div
      v-for="entry in chartDataByCurrency"
      :key="entry.currency"
      class="flex flex-col"
    >
      <div class="text-neutral-500 text-xs uppercase mb-1">
        {{ entry.currency }}
      </div>
      <div :ref="wrapperRef(entry.currency)" />
    </div>
  </div>
</template>

<script>
import { Chart } from 'chart.js'
import { SankeyController, Flow } from 'chartjs-chart-sankey'

Chart.register(SankeyController, Flow)

export default {
  props: ['transactions'],
  computed: {
    // One flow diagram per currency -- two different-currency flows
    // between the same accounts would otherwise merge into one flow
    // width that isn't really an amount of anything.
    chartDataByCurrency () {
      const byCurrency = {}

      this.transactions.forEach((transaction) => {
        const elided = transaction._original.postings.find((p) => p.elided)

        if (!elided) return

        transaction.postings.filter((p) => p !== elided).forEach((posting) => {
          if (posting.amount === 0) return

          const currency = posting.currency
          const from = posting.amount > 0 ? elided.account : posting.account
          const to = posting.amount > 0 ? posting.account : elided.account

          if (!byCurrency[currency]) byCurrency[currency] = []
          const data = byCurrency[currency]
          const found = data.find((d) => d.from === from && d.to === to)

          if (found) {
            found.flow += Math.abs(posting.amount)
          } else {
            data.push({ from, to, flow: Math.abs(posting.amount) })
          }
        })
      })

      const isDark = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches

      return Object.entries(byCurrency).map(([currency, data]) => ({
        currency,
        datasets: [{
          data,
          color: isDark ? 'rgba(255, 255, 255, 0.8)' : 'rgba(0, 0, 0, 0.8)',
          colorFrom: (c) => 'rgb(74, 222, 128)',
          colorTo: (c) => 'rgb(99, 102, 241)',
          colorMode: 'gradient', // or 'from' or 'to'
          size: 'max' // or 'min' if flow overlap is preferred
        }]
      }))
    }
  },
  watch: {
    chartDataByCurrency () {
      this.$nextTick(() => this.makeCharts())
    }
  },
  mounted () {
    this.makeCharts()
  },
  methods: {
    wrapperRef (currency) {
      return `chartWrapper-${currency}`
    },

    makeCharts () {
      for (const entry of this.chartDataByCurrency) {
        this.makeChart(entry)
      }
    },

    makeChart (entry) {
      const wrapper = this.$refs[this.wrapperRef(entry.currency)]
      if (!wrapper) return

      const canvas = document.createElement('canvas')

      canvas.className = 'block p-4'

      wrapper.innerHTML = ''
      wrapper.appendChild(canvas)

      Chart.defaults.font.color = 'white'

      new Chart(canvas, { /* eslint-disable-line no-new */
        type: 'sankey',
        data: { datasets: entry.datasets },
        options: {
          responsive: true,
          animation: false
        }
      })
    }
  }
}
</script>
